import { SET_USER, SET_TOKEN, RESET } from "../constants";

const initialState = {
  token: null,
  user: null,
};

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case RESET:
      return {
        token: null,
        user: null,
      };
    default:
      return state;
  }
};
